import React from "react";
import { createPortal } from "react-dom";

function SelectModalContainer({ children }) {
  return createPortal(<>{children}</>, document.getElementById("select_modal"));
}

export default SelectModalContainer;